import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable } from "rxjs";
import {
  AddNode,
  AddVmPool,
  AddWorkstationDTO,
  HeadNodeInfo,
  MultiNodeActionDTO,
  Node,
  NodeAction,
  VmInfo,
} from "../models/node";
import { EnvironmentService } from "./environment.service";
import { PodInfo } from "./pod-info.service";

@Injectable({
  providedIn: "root",
})
export class NodeService {
  dashboardRedirectSort: string | null = null;

  activeNode: Node | null = null;
  activePod: PodInfo | null = null;

  private selectedPod = new BehaviorSubject<PodInfo | null>(null);
  private selectedNode = new BehaviorSubject<Node | null>(null);
  public SelectedNode = this.selectedNode.asObservable();
  public SelectedPod = this.selectedPod.asObservable();

  updateSelectedNode(node: Node) {
    if (node && this.selectedNode.value != node) {
      this.selectedNode.next(node);
    }
    setTimeout(() => {
      this.SendNodeAction.next(null);
    }, 1000);
  }

  updateSelectedPod(pod: PodInfo) {
    if (pod && this.selectedPod.value != pod) {
      this.selectedPod.next(pod);
    }
    setTimeout(() => {
      //this.SendPodAction.next(null);
    }, 1000);
  }

  getSelectedPod() {
    return this.selectedPod.value;
  }
  getSelectedNode() {
    return this.selectedNode.value;
  }

  private showBillingDetails = new BehaviorSubject<boolean>(false);
  public ShowBillingDetails = this.showBillingDetails.asObservable();
  showBilling(value: boolean) {
    this.showBillingDetails.asObservable();
  }

  // perform node action from advance details panel
  private SendNodeAction = new BehaviorSubject<{
    action: NodeAction;
    node: Node;
  } | null>(null);
  public sendNodeAction = this.SendNodeAction.asObservable();

  updateNodeAction(action: { action: NodeAction; node: Node } | null): void {
    this.SendNodeAction.next(action);
    setTimeout(() => {
      this.SendNodeAction.next(null);
    }, 1000);
  }

  // apis
  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();

    const obs = Observable.create((observer: any) => {
      reader.onloadend = (e) => {
        observer.error(JSON.parse(reader.result.toString()));
        observer.complete();
      };
    });
    reader.readAsText(err.error);
    return obs;
  }

  // private nodeActions: NodeAction[] = [
  //   { name: "Start", value: "1", title:"Start node", icon:"bi-play", disabled: false },
  //   { name: "Stop", value: "2", title:"Stop node", icon:"bi-stop", disabled: false },
  //   { name: "Connect", value: "3", title:"Connect Node", icon:"bi-link", disabled: true },
  //   { name: "Restart", value: "4", title:"Restart selected node", icon:"bi-bootstrap-reboot", disabled: false },
  //   { name: "Remove Session", value: "5", title:"Removed on-going sessions", icon:"bi-box-arrow-right", disabled: false },
  //   { name: "Reports", value: "6", title:"View reports of node", icon:"bi-graph-up", disabled: false },
  //   { name: "Terminal", value: "7", title:"Open terminal", icon:"bi-terminal", disabled: true },
  // ]

  // getNodeActions(){
  //   return this.nodeActions;
  // }

  constructor(private http: HttpClient, private env: EnvironmentService) {}

  getNodeInfo(depName: string, nodeName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/Deployment/" +
      depName +
      "/NodeInfo/name=" +
      nodeName;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  setNodeInfo(depName: string, nodeName: string, node: VmInfo) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/Deployment/" +
      depName +
      "/NodeInfo/name=" +
      nodeName;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.post(baseUrl, node, { headers: headers });
  }

  getAllNodesForUser() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/GetAllNodesForUser";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getNodesForDeployment(depName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/Deployment/" +
      depName +
      "/nodelist";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  triggerNodeAction(
    nodeName: string,
    depName: string,
    action: string,
    type: string,
    forcefully: boolean,
    useVncFile: boolean,
    nodeType: string,
    skipCloud: boolean, 
  ) {
    try {
      let baseUrl =
        this.env.envVariables.httpProtocol +
        this.env.envVariables.webHost +
        "VmInfoes/Deployment/" +
        depName +
        "/nodes/" +
        nodeName +
        "/action=" +
        action +
        "/" +
        forcefully;

      let headers = new HttpHeaders();
      headers = headers
        .set("Content-Type", "application/json")
        .set("Cache-Control", "no-cache")
        .set("nodeTypes", nodeType)
        .set("skipDeployment", skipCloud.toString());
      let responseType;
      if (action == "3") {
        if (type.toLowerCase() == "windows") {
          responseType = "blob";
          return this.http
            .post(baseUrl, null, {
              headers: headers,
              observe: "response",
              responseType: responseType,
            })
            .pipe(catchError(this.parseErrorBlob));
        } else {
          if (useVncFile == false) {
            responseType = "text";
            return this.http.post(baseUrl, null, {
              headers: headers,
              observe: "response",
              responseType: responseType,
            });
          } else {
            responseType = "blob";
            return this.http
              .post(baseUrl, null, {
                headers: headers,
                observe: "response",
                responseType: responseType,
              })
              .pipe(catchError(this.parseErrorBlob));
          }
        }
      } else if (action == "16") {
        responseType = "blob";
        return this.http
          .post(baseUrl, null, {
            headers: headers,
            observe: "response",
            responseType: responseType,
          })
          .pipe(catchError(this.parseErrorBlob));
      } else {
        responseType = "json";
        return this.http.post(baseUrl, null, {
          headers: headers,
          observe: "response",
          responseType: responseType,
        });
      }

      //return this.http.post(baseUrl, null, { headers: headers, observe: 'response', responseType: responseType }).pipe(catchError(this.parseErrorBlob));
    } catch (e) {}
  }

  scaleUpDownNodes(depName: string, noOfCores: number) {
    try {
      let baseUrl =
        this.env.envVariables.httpProtocol +
        this.env.envVariables.webHost +
        "VmInfoes/Deployment/" +
        depName +
        "/ScaleNodes/cores=" +
        noOfCores;

      let headers = new HttpHeaders();
      headers = headers
        .set("Content-Type", "application/json")
        .set("Cache-Control", "no-cache");

      let options = { headers: headers };

      return this.http.post<any>(baseUrl, null, options);
    } catch (e) {}
  }

  addNode(nodeData: AddNode[]) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/AddNode";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.post(baseUrl, nodeData, { headers: headers });
  }

  enableDisableAutoScale(depName: string, autoScaleFlag: boolean) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "ProfileInfoes/Deployment/" +
      depName +
      "/rescale";

    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache")
      .set("AutoScaleFlag", String(autoScaleFlag));

    return this.http.put<any>(baseUrl, null, { headers: headers });
  }

  startStopAllNodes(depName: string, action: string) {
    let baseUrl = `${
      this.env.envVariables.httpProtocol + this.env.envVariables.webHost
    }ProfileInfoes/Deployment/${depName}/profileAction=${action}`;

    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");

    return this.http.post(baseUrl, action, { headers: headers });
  }

  getGpuNodeInfoes(depName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/Deployment/" +
      depName +
      "/GpuComputeVms";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getHeadNodeNameIp(depName: string): Observable<HeadNodeInfo> {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/Deployment/" +
      depName +
      "/GpuHeadnodeNameIp";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get<HeadNodeInfo>(baseUrl, { headers: headers });
  }

  setNodeGroup(depName: string, nodeName: string, nodeGroupName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/Deployment/" +
      depName +
      "/NodeName=" +
      nodeName +
      "/NodeGroupName=" +
      nodeGroupName;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.post(baseUrl, { headers: headers });
  }

  getAllDeploymentNodes() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/Deployment/All/nodelist";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getAllNodeCount(userName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/UserName/" +
      userName +
      "/NodeCount";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getAllNodesForUserByRange(entries: number) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/GetAllNodesForUser/Entry/" +
      entries;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  multiNodeAction(actionValue: number, wsObj: MultiNodeActionDTO) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/MultiNodeAction/" +
      actionValue;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.post(baseUrl, wsObj, { headers: headers });
  }

  addBulkNodes(nodes: Array<AddWorkstationDTO>) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "UserInfoes/importNodes";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.post<any>(baseUrl, nodes, { headers: headers });
  }

  getNodeNetworkInfo(nodeName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/" +
      nodeName +
      "/NetworkInfo";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  updateNodeDetails(nodeObj: AddNode) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/" +
      nodeObj.MachineName +
      "/UpdateInfo";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.put<any>(baseUrl, nodeObj, { headers: headers });
  }

  getAllWSNames(depName: string, nodeType) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/" +
      depName +
      "/WorkstationNames";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("NodeType", nodeType);
    return this.http.get(baseUrl, { headers: headers });
  }

  getAllWorkstations() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/GetAllWorkstations";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  checkIsHeadNodeActive(depName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/Deployment/" +
      depName +
      "/CheckIfHeadNodeActive";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getUseVncFileTagValue(depName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/UseVncFile/Deployment/" +
      depName;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getWSDeployments() {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/Workstation/GetWorksationDepInfo";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getGpuMasterListForNode(depName: string, nodeName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `VmInfoes/Deployment/${depName}/Node/${nodeName}/GetGpuMasterList`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  getGpuSlaveListForMaster(
    depName: string,
    nodeName: string,
    masterId: string
  ) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `VmInfoes/Deployment/${depName}/Node/${nodeName}/GetGpuSlaveList`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("MasterId", masterId);
    return this.http.get(baseUrl, { headers: headers });
  }

  createInstance(
    depName: string,
    nodeName: string,
    masterId: string,
    selectedFrame
  ) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `VmInfoes/Deployment/${depName}/Node/${nodeName}/CreateInstance`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("MasterId", masterId)
      .set("SelectedFrame", selectedFrame);
    return this.http.get(baseUrl, { headers: headers });
  }

  getGpuSlaveListForMasterToAttach(
    depName: string,
    nodeName: string,
    masterId: string,
    action: string = "attach"
  ) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `VmInfoes/Deployment/${depName}/Node/${nodeName}/GetGpuSlaveListToAttach`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("MasterId", masterId)
      .set("Action", action);
    return this.http.get(baseUrl, { headers: headers });
  }

  detachvGPU(
    nodeName: string,
    masterId: string,
    depName: string,
    vmId: string,
    hostDeviceId: string = null
  ) {
    if (!hostDeviceId) {
      hostDeviceId = "none";
    }
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `VmInfoes/Deployment/${depName}/Node/${nodeName}/DetachvGPU`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("MasterId", masterId)
      .set("VmId", vmId)
      .set("HostDeviceId", hostDeviceId);
    return this.http.get(baseUrl, { headers: headers });
  }

  attachvGPU(
    depName: string,
    nodeName: string,
    instanceName: string,
    vmId: string,
    hostDeviceId: string = null
  ) {
    if (!hostDeviceId) {
      hostDeviceId = "none";
    }
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `VmInfoes/Deployment/${depName}/Node/${nodeName}/Instance/${instanceName}/VmId/${vmId}/HostDeviceId/${hostDeviceId}/AttachvGPU`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.post(baseUrl, { headers: headers });
  }

  getConnectorType(depName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/ConnectorType/Deployment/" +
      depName;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  deleteVm(depName: string, vmName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/Deployment/" +
      depName +
      "/vmName=" +
      vmName;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.delete(baseUrl, { headers: headers });
  }

  assignHostNodeVmId(hostNodeId: string, wsNames: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `VmInfoes/AssignHostNodeVmId`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");

    let attachChildNodesToHost = { hostId: hostNodeId, vmNames: wsNames };

    return this.http.post(baseUrl, attachChildNodesToHost, {
      headers: headers,
    });
  }

  getNodeDescription(depName) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/NodeDescription/Deployment/" +
      depName;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.get(baseUrl, { headers: headers });
  }

  updateNodeRdProtocolForDeployment(
    rdProtocol: string,
    nodeName: string,
    depName: string
  ) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/" +
      depName +
      "/" +
      nodeName +
      "/" +
      rdProtocol +
      "/updateRdProtocol";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.put<any>(baseUrl, rdProtocol, { headers: headers });
  }

  resizeNodeService(nodeName: string, depName: string, instanceCode: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      `VmInfoes/NodeName/${nodeName}/InstanceCode/${instanceCode}/Deployment/${depName}/ResizeNode`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");
    return this.http.post(baseUrl, { headers: headers });
  }

  addNodeFromTemplate(nodeData: AddVmPool, depName: string) {
    let baseUrl =
      this.env.envVariables.httpProtocol +
      this.env.envVariables.webHost +
      "VmInfoes/VmPool";
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("DepName", depName);
    return this.http.post(baseUrl, nodeData, { headers: headers });
  }

    syncVirtualMachinesService(
      depName: string,
      depJsonBody: any[],
      nodeGroup: string = ''
    ) {
      try {
        let baseUrl =
          this.env.envVariables.httpProtocol +
          this.env.envVariables.webHost +
          "VmInfoes/SyncVirtualMachines";
  
        let headers = new HttpHeaders();
        headers = headers
          .set("Content-Type", "application/json")
          .set("Cache-Control", "no-cache")
          .set("Deployment", depName)
          .set("NodeGroup", nodeGroup);
  
        let options = { headers: headers };
  
        return this.http.post<any>(baseUrl, JSON.stringify(depJsonBody), options);
      } catch (e) {}
    }
}
